import PropTypes from 'prop-types';
import { cn } from 'utils';

RButtonIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  children: PropTypes.any,
  asButton: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  onClick: PropTypes.func,
};

export function RButtonIcon({
  size = 24,
  color = '#989898',
  onClick = () => {},
  children,
  asButton = false,
  disabled = false,
  readonly = false,
}) {
  const isInactive = disabled || readonly;
  const Component = asButton ? 'button' : 'div';

  return (
    <Component
      type={asButton ? 'button' : undefined}
      onClick={!disabled ? onClick : undefined}
      className={cn(
        'relative z-[2] inline-flex items-center justify-center',
        'border-0 bg-transparent p-0',
        isInactive ? 'cursor-default' : 'cursor-pointer',
        'group'
      )}
    >
      {children}

      <div
        className={cn(
          'absolute left-1/2 top-1/2 -z-[1]',
          'h-0 w-0 -translate-x-1/2 -translate-y-1/2',
          'rounded-full transition-all duration-150 ease-linear',
          !isInactive &&
            'group-hover:h-[var(--hover-size)] group-hover:w-[var(--hover-size)]'
        )}
        style={{
          backgroundColor: `${color}20`,
          '--hover-size': `${size * 1.5}px`,
        }}
      />
    </Component>
  );
}
